import { createContext, useContext } from 'react';

interface SetupReviewScope {
  restaurantId: string;
  restrictedToRestaurant?: boolean;
  runId: string;
  returnPath: string;
}

// Review pages depend on the context only, not the setup workspace's UI/bootstrap.
export const SetupReviewContext = createContext<SetupReviewScope | null>(null);
export const useSetupReviewContext = () => useContext(SetupReviewContext);
